export enum ButtonType {
  Submit = "submit",
  Button = "button",
}

export enum ButtonSize {
  Small = "small",
  Large = "large",
}

export enum ButtonVariant {
  Basic = "basic",
  Filled = "filled",
  Bordered = "bordered",
}

// Named by role; `resolveButtonColor` maps each to its tokens.
export enum ButtonColor {
  Primary = "primary",
  Secondary = "secondary",
  Danger = "danger",
  Neutral = "neutral",
  Muted = "muted",
}
